import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { LocalFilesPage } from './local-files';
import { TranslateModule } from '@ngx-translate/core';
import { PipesModule } from '../../pipes/pipes.module';
import { ComponentsModule } from '../../components/components.module';

@NgModule({
  declarations: [
    LocalFilesPage,
  ],
  imports: [
    IonicPageModule.forChild(LocalFilesPage),
    TranslateModule.forChild(),
    ComponentsModule,
    PipesModule
  ],
})
export class LocalFilesPageModule {}



// WEBPACK FOOTER //
// ./src/pages/local-files/local-files.module.ts